<template>
    <!-- DSR查询 -->
    <div class="page-container">
        <el-form id="boxDiv1" class="form-panel" label-position="top" ref="bookingFormRef" :rules="DsrQueryFormRules" :model="DsrQueryForm">
          <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">Condition</span>
                </el-col>
                </div>
                </el-row>
         <el-row class="content-panel position-parent" :gutter="10">
                <el-col :span="6">
                    <el-form-item label="Carrier Name:" prop="carrierName">
                        <el-associate style="width: 100%;"
                            :columns="associate_columns_carrier"
                            :query-method="associate_queryMethod_carrier"
                            class="input_length"
                            clearable
                            case="upper"
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="custAlias"
                            value-prop="custAlias"
                            placeholder=""
                            @change="onCarrierChange"
                            v-model="DsrQueryForm.carrierName"
                            size="mini"
                        />
                    </el-form-item>
                </el-col>
                    <el-col :span="3">
                    <el-form-item label="ETD From:">
                        <el-date-picker
                            v-model="DsrQueryForm.startEtd"
                            style="width:100%;"
                            align="right"
                            type="date"
                            size="mini"
                            :placeholder="$t('table.selectTime')"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="ETD To:">
                        <el-date-picker
                            v-model="DsrQueryForm.endEtd"
                            style="width:100%;"
                            align="right"
                            type="date"
                            size="mini"
                            :placeholder="$t('table.selectTime')"
                            @change="changeEndEtd"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="Create From:">
                        <el-date-picker
                            v-model="DsrQueryForm.startTime"
                            type="date"
                            style="width: 100%"
                            align="right"
                            size="mini"
                            :placeholder="$t('table.selectTime')"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="Create to:">
                        <el-date-picker
                            v-model="DsrQueryForm.endTime"
                            type="date"
                            style="width: 100%"
                            align="right"
                            size="mini"
                            :placeholder="$t('table.selectTime')"
                            @change="changeEndTime"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
<!--                    <el-form-item label="Order Status:">-->
<!--                        <el-select class="length_input" value-key="key" size="mini" v-model="DsrQueryForm.orderStatus">-->
<!--                            <el-option-->
<!--                                v-for="item in StatusList"-->
<!--                                :key="item.value"-->
<!--                                :label="item.name"-->
<!--                                :value="item.value"-->
<!--                            >-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                  <el-form-item label="SHPT ID:">
                    <el-input style="width: 100%;"
                              class="input_length"
                              clearable
                              v-model="DsrQueryForm.shptId"
                              size="mini"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-row>
                        <el-col :span="16">
                            <el-form-item label="VSL/VOY:">
                                <el-associate style="width: 100%;"
                                                :columns="associate_columns_vessel"
                                                :query-method="associate_queryMethod_vessel"
                                                class="input_length"
                                                clearable
                                                :query-length="0"
                                                :default-first-option="true"
                                                label-prop="vesselName"
                                                value-prop="mdVoyagePlanId"
                                                placeholder=""
                                                v-model="DsrQueryForm.vesselNameEn"
                                                size="mini"
                                                @change="onChangeVessel"
                                                case="upper"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-associate style="width: 100%;"
                                                :columns="associate_columns_voyage"
                                                :query-method="associate_queryMethod_voyage"
                                                class="input_length"
                                                clearable
                                                :query-length="0"
                                                :default-first-option="true"
                                                label-prop="voyage"
                                                value-prop="mdVoyagePlanId"
                                                placeholder=""
                                                v-model="DsrQueryForm.voyage"
                                                size="mini"
                                                case="upper"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="MBL NO. :">
                        <el-input style="width: 100%;"
                            class="input_length"
                            clearable
                            v-model="DsrQueryForm.mblNo"
                            size="mini"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="REF NO.:">
                        <el-input style="width: 100%;"
                            class="input_length"
                            clearable
                            v-model="DsrQueryForm.refNo"
                            size="mini"
                        />
                    </el-form-item>
                </el-col>
                    <el-col :span="6">
<!--                    <el-form-item label="SHPT ID:">-->
<!--                        <el-input style="width: 100%;"-->
<!--                            class="input_length"-->
<!--                            clearable-->
<!--                            v-model="DsrQueryForm.shptId"-->
<!--                            size="mini"-->
<!--                        />-->
<!--                    </el-form-item>-->
                </el-col>
                <el-col>
                    <el-row type="flex" align="center" justify="end">
                        <el-button type="primary" size="small" plain @click="handlerSearch">Search</el-button>
                        <el-button type="primary" size="small" plain @click="handlerReset">Reset</el-button>
                        <el-button type="primary" size="small" plain @click="handlerExcel">EXCEL</el-button>
                    </el-row>
                </el-col>
         </el-row>
                <!-- 状态栏-start -->
          <el-row>
                <el-col class="tabsContainer tab-module">
                    <el-tabs
                    type="border-card"
                    v-model="activeName"
                    @tab-click="handleClick"
                    >
                    <el-tab-pane
                        :label="'ALL(' + count0 + ')'"
                        name="ALL"
                    ></el-tab-pane>
                    <el-tab-pane
                        v-for="(item, index) in ebOsOrderType"
                        :key="index"
                        :name="item.value"
                    >
                        <span slot="label">{{ item.name + '(' }}<span
                        :class="[item.count > 0? 'hasTabPane': '']">{{ item.count }}</span><span>{{ ')' }}</span></span>
                    </el-tab-pane>
                    </el-tabs>
                </el-col>
          </el-row>
                <!-- 状态栏-end -->
          <el-row style="padding: 0 1px" >
                <hot-table
                    ref="newOrderTableRef"
                     renderAllRows="true"
                    :data-source="TableDataSource"
                    :settings="TableSettings"
                    col-settings-key="newOrder"
                    style="margin-top:8px"
                    @cellDblclick="dbClickCustBizNo"
                >
                    <hot-column :has-tip="true" data="hblNo" title="REF NO." width="150">
                        <column-link-renderer url="/overseas-agency/DsrDetail" param-name="goOrderId" type="edit"
                                    hot-renderer class="custBizNo"></column-link-renderer>
                    </hot-column>
                    <hot-column :has-tip="true" data="mblNo" title="MBL NO." width="150"></hot-column>
                    <!-- <hot-column :has-tip="true" data="hblNo" title="HBL NO." width="150"></hot-column> -->
                    <hot-column :has-tip="true" data="carrierShortName" title="CARRIER" width="150"></hot-column>
                    <hot-column :has-tip="true" data="noOfPackage" title="NO OF PCS" width="150"></hot-column>
                    <hot-column :has-tip="true" data="grossWeight" title="GROSS WEIGHT" width="150"></hot-column>
                    <hot-column :has-tip="true" data="cube" title="MEASUREMENT" width="150"></hot-column>
                    <hot-column :has-tip="true" data="sumCtnNo" title="CNTR NO" width="150"></hot-column>
                    <hot-column :has-tip="true" data="ctnNum" title="CNTR SIZE AND NO" width="150"></hot-column>
                    <hot-column :has-tip="true" data="vesselNameEn" title="VSL" width="150"></hot-column>
                    <hot-column :has-tip="true" data="voyage" title="VOY" width="150"></hot-column>
                    <hot-column :has-tip="true" data="polName" title="POL" width="150"></hot-column>
                    <hot-column :has-tip="true" data="podName" title="POD" width="150"></hot-column>
                    <hot-column :has-tip="true" data="tradeTerms" title="FREIGHT TERM" width="150"></hot-column>
                    <hot-column :has-tip="true" data="routing" title="ROUTING" width="150"></hot-column>
                    <hot-column :has-tip="true" data="sendVGMTime" title="VGM" width="150" date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
                    <hot-column :has-tip="true" data="sendSITime" title="SI" width="150" date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
                    <hot-column :has-tip="true" data="etd" title="ETD" width="150" date-format="YYYY-MM-DD"></hot-column>
                    <hot-column :has-tip="true" data="etd2" title="2ND LEG ETD" width="150" date-format="YYYY-MM-DD"></hot-column>
                    <hot-column :has-tip="true" data="eta2" title="2ND LEG ETA" width="150" date-format="YYYY-MM-DD"></hot-column>
                    <hot-column :has-tip="true" data="etd3" title="3ND LEG ETD" width="150" date-format="YYYY-MM-DD"></hot-column>
                    <hot-column :has-tip="true" data="eta3" title="3ND LEG ETA" width="150" date-format="YYYY-MM-DD"></hot-column>
                    <hot-column :has-tip="true" data="eta" title="ETA" width="150" date-format="YYYY-MM-DD"></hot-column>
                    <hot-column :has-tip="true" data="cargoValue" title="CARGO VALUE" width="150"></hot-column>
                    <hot-column :has-tip="true" data="hblStatus" title="HBL STATUS" width="150" dictName="HBL_DOCUMENT_STATUS"></hot-column>
                    <hot-column :has-tip="true" data="mblStatus" title="MBL STATUS" width="150" dictName="DOCUMENT_STATUS"></hot-column>
                    <hot-column :has-tip="true" data="orderRemark" title="REMARK" width="150"></hot-column>
                    <hot-column :has-tip="true" data="overseasNameEn" title="PERSON IN CHARGE" width="150"></hot-column>
                </hot-table>
                <div class="pg_div">
                    <el-pagination
                    :current-page="pageConfig.currentPage"
                    :layout="pageConfig.layout"
                    :page-size="pageConfig.pageSize"
                    :page-sizes="pageConfig.pageSizes"
                    :total="pageConfig.total"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    />
                </div>
         </el-row>
        </el-form>
    </div>
</template>

<script>
import columnLinkRenderer from "../../components/CustomRenderer/columnLinkRenderer";
import {
  queryCarrierInfo,
  queryCtnCompanyInfo,
  queryCtnSizeInfo,
  queryDictRows,
  queryPoInfo,
  querySysCorpInfo,
  querySysUserInfo,
  queryVesselInfo,
  queryVoyageInfo,
  queryDictionaryByCodeType
} from "@/api/commonService";
 import { queryOverSeaAgentOrders } from '@/api/overseas'
import {downloadExcel} from "@/utils/downloadExcel";
export default {
 name: "DsrQuery",
 components: {
    columnLinkRenderer,
  },
    data() {
        return {
        StatusAllList: [],
        ebOsOrderType: [
               /*  { name: "New Order",
                  serialNumber: 1
                },
                { name: "Departure",
                  serialNumber: 2
                },
                { name: "Pre-alert sent",
                  serialNumber: 3
                },
                { name: "Transit",
                  serialNumber: 4
                },
                { name: "Arrival",
                  serialNumber: 5
                },
                { name: "D/O Released",
                  serialNumber: 6
                },
                { name: "Empty Return",
                  serialNumber: 7
                }, */
                ],
            DsrQueryFormRules: {},
            DsrQueryForm: {
              mblNo: '',
              refNo: '',
              startEtd: new Date(
                new Date(
                  new Date(
                    new Date().getTime() - 24 * 1000 * 3600 * 30
                  ).toLocaleDateString()
                ).getTime()
              ),
              endEtd: new Date(
                new Date(
                  new Date(
                    new Date().getTime() + 24 * 1000 * 3600 * 61
                  ).toLocaleDateString()
                ).getTime() +
                24 * 1000 * 3600 - 1
              ),
            },
            // 船公司
            associate_columns_carrier: [
                {
                title: this.$t("associate.custAlias"),
                field: "custAlias",
                },
                {
                title: this.$t("associate.consignorName"),
                field: "custNameCn",
                },
                {
                title: this.$t("associate.mnemonicCode"),
                field: "mnemonicCode",
                },
            ],
            pickerOptions: {
                shortcuts: [
                {
                    text: this.$t('table.today'),
                    onClick(picker) {
                    picker.$emit("pick", new Date());
                    },
                },
                {
                    text: this.$t('table.yesterday'),
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit("pick", date);
                    },
                },
                {
                    text: this.$t('table.aWeekAgo'),
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", date);
                    },
                },
                ],
            },
            StatusList: [],
            //大船/驳船船名联想控件
            associate_columns_vessel: [
                {
                    title: this.$t("associate.vesselName"),
                    field: "vesselName",
                },
                {
                    title: this.$t("associate.voyage"),
                    field: "voyage",
                },
            ],
            //航次联想控件
            associate_columns_voyage: [
                {
                    title: this.$t("associate.vesselName"),
                    field: "vesselName",
                },
                {
                    title: this.$t("associate.voyage"),
                    field: "voyage",
                },
                {
                    title: this.$t("associate.voyageCode"),
                    field: "voyageCode",
                },
            ],
            // 表格数据
            TableDataSource: [],
            TableSettings: {
                height: 340,
                stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
                ...this.$systemConfig.tableConfig,
            },
            // 分页
            pageConfig: {
                layout: "total, sizes, prev, pager, next, jumper",
                total: 0,
                pageSize: 50,
                pagerCount: 10,
                currentPage: 1,
                pageSizes: [50, 100, 200, 300],
            },
             //各订单状态数量
            count0: 0,
             //tab状态栏
             activeName: "ALL",
        };
    },
    async created() {

    },

    mounted() {
        let self = this;
            if(this.$cookies.get('language')==='en'){
              this.associate_columns_carrier=[
                {
                title: this.$t("associate.custAlias"),
                field: "custAlias",
                },
                {
                title: this.$t("associate.consignorName"),
                field: "custNameEn",
                },
                {
                title: this.$t("associate.mnemonicCode"),
                field: "mnemonicCode",
                },
            ]
      }
        this.TableSettings.height = document.body.clientHeight - 410
      self.queryHblStatus();
        self.queryEbOrderStatus();
        let _this = this;
        //表格响应式
        _this.resizeObserver = new ResizeObserver(entries => {
            _this.$nextTick(() => {
                _this.$refs.newOrderTableRef.resizeTo(
                    entries[0].target.clientWidth - 20
                );
            });
        });
        _this.resizeObserver.observe(document.getElementById("boxDiv1"));
    },
/*     beforeDestroy() {
        let _this = this;
        // 离开页面删除检测器和所有侦听器
        _this.resizeObserver.disconnect();
    }, */
    activated() {
    setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.newOrderTableRef.render()
          })
    },100);
  },
    methods: {
      handleClick(tab, event) {
/*            setTimeout(() => {
            this.$nextTick(() => {
          this.$refs.ReleasedTableRef.render()
          })
    },100); */
    console.log(tab)
          let self = this;
      if (tab.name === "ALL") {
        self.TableDataSource = self.StatusAllList;
        self.pageConfig.total = self.count0;
                console.log(self.TableDataSource)
                debugger
        return;

      }
      self.pageConfig.currentPage = 1;
      let target = self.ebOsOrderType.find(
        (item) => item.value === tab.paneName
      );
      self.TableDataSource = target.filterList;
      self.pageConfig.total = target.count
    },
        changeEndTime() {
      let self = this;
     /*  self.searchData.endTime = new Date(self.searchData.endTime.getTime() + 1000*24*3600 -100  ) */
      self.DsrQueryForm.endTime = new Date(self.DsrQueryForm.endTime.getTime() + 1000*24*3600 -100  )
    },
        changeEndEtd() {
       let self = this;
      self.DsrQueryForm.endEtd = new Date(self.DsrQueryForm.endEtd.getTime() + 1000*24*3600 -100  )
    },
        // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      console.log( this.pageConfig.pageSize)
      let self = this;
      self.handlerSearch(this.pageConfig.currentPage);
    },
        // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val;
      let self = this;
      self.handlerSearch();
    },
        // 船公司联想控件数据源
        associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
            let params = {};
            if (keyword === "") {
                params = {
                custType4: "%SO%",
                isDeleted6: "0",
                isBlacklist: "0",
                };
            } else {
                params = {
                custAlias0: "%" + keyword + "%",
                custNameCn1: "%" + keyword + "%",
                custType4: "%SO%",
                isDeleted6: "0",
                isBlacklist: "0",
                mdmCustCode3: "%" + keyword + "%",
                mnemonicCode2: "%" + keyword + "%",
                };
            }

            let data = {
              action: "query",
              crudType: "SELECT",
              sorting: ["CTS_ILPCsCust.custNameCn"],
              mainModelName: "CTS_ILPCsCust",
              tag: "CTS_WEB_es",
              where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
              currentPage: currentPage,
              pageSize: pageSize,
              returnPage: true,
              returnTotal: false,
              reqArgs: params,
              fields: [
                "CTS_ILPCsCust.csCustId",
                "CTS_ILPCsCust.custAlias",
                "CTS_ILPCsCust.custNameCn",
                "CTS_ILPCsCust.custNameEn",
                "CTS_ILPCsCust.customsRegisteredNo",
                "CTS_ILPCsCust.esCustType",
                "CTS_ILPCsCust.isActive",
                "CTS_ILPCsCust.isBlacklist",
                "CTS_ILPCsCust.isCustomer",
                "CTS_ILPCsCust.isDeleted",
                "CTS_ILPCsCust.isOneTimeCustomer",
                "CTS_ILPCsCust.isSettlement",
                "CTS_ILPCsCust.isSupplier",
                "CTS_ILPCsCust.legalPerson",
                "CTS_ILPCsCust.mdmCustCode",
                "CTS_ILPCsCust.mobileNo",
                "CTS_ILPCsCust.postCode"
              ],
              enableCascade: true
            };
            return new Promise((resolve) => {
                queryCarrierInfo(data).then((res) => {
                console.log("queryCarrierInfo", res);
                resolve({
                    records: res.data.data,
                    total: res.data.totalRecord,
                });
                });
            }).catch((err) => {
                console.log(err);
            });
        },
        // 船名联想控件数据源
        associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
            let params = {};
            if (keyword === "") {
                params = {
                isDeleted2: "0",
                };
            } else {
                params = {
                vesselName0: "%" + keyword + "%",
                voyage1: "%" + keyword + "%",
                };
            }

            let data = {
                action: "query",
                crudType: "SELECT",
                sorting: ["CTS_ILPMdVoyagePlan.voyage"],
                mainModelName: "CTS_ILPMdVoyagePlan",
                tag: "CTS_ILP_es",
                where:
                "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
                currentPage: currentPage,
                pageSize: pageSize,
                returnPage: true,
                returnTotal: false,
                reqArgs: params,
                fields: [
                "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
                "CTS_ILPMdVoyagePlan.createTime",
                "CTS_ILPMdVoyagePlan.principalGroupCode",
                "CTS_ILPMdVoyagePlan.customsVesselName",
                "CTS_ILPMdVoyagePlan.lastModifyTime",
                "CTS_ILPMdVoyagePlan.isDeleted",
                "CTS_ILPMdVoyagePlan.remark",
                "CTS_ILPMdVoyagePlan.recordVersion",
                "CTS_ILPMdVoyagePlan.voyage",
                "CTS_ILPMdVoyagePlan.voyageCode",
                "CTS_ILPMdVoyagePlan.createOffice",
                "CTS_ILPMdVoyagePlan.customsVoyage",
                "CTS_ILPMdVoyagePlan.vesselId",
                "CTS_ILPMdVoyagePlan.appCode",
                "CTS_ILPMdVoyagePlan.createOfficeName",
                "CTS_ILPMdVoyagePlan.creatorName",
                "CTS_ILPMdVoyagePlan.creatorId",
                "CTS_ILPMdVoyagePlan.customsVesselId",
                "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
                "CTS_ILPMdVoyagePlan.lastModifyOffice",
                "CTS_ILPMdVoyagePlan.lastModifierName",
                "CTS_ILPMdVoyagePlan.ioFlag",
                "CTS_ILPMdVoyagePlan.carrierId",
                "CTS_ILPMdVoyagePlan.lastModifierId",
                "CTS_ILPMdVoyagePlan.vesselName",
                "CTS_ILPMdVoyagePlan.carrierName",
                ],
                enableCascade: true,
            };
            return new Promise((resolve) => {
                queryVoyageInfo(data).then((res) => {
                console.log("res", res);
                resolve({
                    records: res.data.data,
                    total: parseInt(res.data.totalRecord),
                });
                });
            }).catch((err) => {
                console.log(err);
            });
        },
        // 航次联想控件数据源
        associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
            let params = {};
            let whereObj = null
            if (keyword === "") {
                params = {
                isDeleted3: "0",
                };
            } else {
                params = {
                isDeleted3: "0",
                vesselName0: "%" + keyword + "%",
                voyage1: "%" + keyword + "%",
                voyageCode2: "%" + keyword + "%",
                };
            }

            if(this.DsrQueryForm.vesselName) {
                params.vesselId = this.DsrQueryForm.vesselId
                whereObj = "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)"
            }else {
                whereObj = "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)"
            }

            let data = {
                action: "query",
                crudType: "SELECT",
                mainModelName: "CTS_ILPMdVoyagePlan",
                tag: "CTS_ILP_es",
                where: whereObj,
                currentPage: currentPage,
                pageSize: pageSize,
                returnPage: true,
                returnTotal: false,
                reqArgs: params,
                fields: [
                "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
                "CTS_ILPMdVoyagePlan.createTime",
                "CTS_ILPMdVoyagePlan.principalGroupCode",
                "CTS_ILPMdVoyagePlan.customsVesselName",
                "CTS_ILPMdVoyagePlan.lastModifyTime",
                "CTS_ILPMdVoyagePlan.isDeleted",
                "CTS_ILPMdVoyagePlan.remark",
                "CTS_ILPMdVoyagePlan.recordVersion",
                "CTS_ILPMdVoyagePlan.voyage",
                "CTS_ILPMdVoyagePlan.voyageCode",
                "CTS_ILPMdVoyagePlan.createOffice",
                "CTS_ILPMdVoyagePlan.customsVoyage",
                "CTS_ILPMdVoyagePlan.vesselId",
                "CTS_ILPMdVoyagePlan.appCode",
                "CTS_ILPMdVoyagePlan.createOfficeName",
                "CTS_ILPMdVoyagePlan.creatorName",
                "CTS_ILPMdVoyagePlan.creatorId",
                "CTS_ILPMdVoyagePlan.customsVesselId",
                "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
                "CTS_ILPMdVoyagePlan.lastModifyOffice",
                "CTS_ILPMdVoyagePlan.lastModifierName",
                "CTS_ILPMdVoyagePlan.ioFlag",
                "CTS_ILPMdVoyagePlan.carrierId",
                "CTS_ILPMdVoyagePlan.lastModifierId",
                "CTS_ILPMdVoyagePlan.vesselName",
                "CTS_ILPMdVoyagePlan.carrierName",
                ],
                enableCascade: true,
            };

            return new Promise((resolve) => {
                queryVoyageInfo(data).then((res) => {
                console.log("queryVoyageInfo", res);
                resolve({
                    records: res.data.data,
                    total: res.data.totalRecord,
                });
                });
            }).catch((err) => {
                console.log(err);
            });
        },
        onChangeVessel(value, selectedRows) {
            console.log("selectedRows", selectedRows);
            this.DsrQueryForm.vesselName = selectedRows.vesselName;
            this.DsrQueryForm.voyage = selectedRows.voyage;
            this.DsrQueryForm.vesselId = selectedRows.vesselId;
        },
        // 搜索
        //各订单状态数量
        filterStatus(data) {
        let self = this;
        self.StatusAllList = JSON.parse(JSON.stringify(data));
        self.initStatus();
        self.ebOsOrderType.forEach((dictItem) => {
            let filterList = data.filter(
            (item) => {
             return  item.status.indexOf(dictItem.name) !==-1
                }
            );
            dictItem.filterList = filterList;
            dictItem.count = filterList.length;
        });

        if (self.activeName !== 'ALL') {
            let targetStatus = self.ebOsOrderType.find(item => item.value === self.activeName)
            self.TableDataSource = targetStatus.filterList
        }
        },
        initStatus() {
        let self = this;
        self.ebOsOrderType.forEach((dictItem) => {
            dictItem.count = 0;
        });
        },
        handlerSearch() {
            let self = this;
            if(self.DsrQueryForm.refNo === '' && self.DsrQueryForm.mblNo === ''){
              if (self.DsrQueryForm.startEtd === null || self.DsrQueryForm.endEtd === null){
                self.$coreMethods.message("warning", "Please Input ETD TO and ETD TO");
                return;
              }
              if (self.DsrQueryForm.endEtd.getTime() - self.DsrQueryForm.startEtd.getTime() > 1000 * 3600 * 24 * 122){
                self.$coreMethods.message("warning", "Must in 4 Month")
                return;
              }
            }
            /* var custId = this.$store.state.user.userInfo.custId; */
            let userInfo=JSON.parse(localStorage.getItem('userInfo'))
            var custId = userInfo.custId;
            var data={
                page: this.pageConfig.currentPage,
                pageSize: this.pageConfig.pageSize,
                overseaAgentId: custId,
               /*  settleAgentId: '6843204958103347200', */
                carrierId: this.DsrQueryForm.carrierId,
                etdStart: this.DsrQueryForm.startEtd,
                etdEnd: this.DsrQueryForm.endEtd,
                createTimeStart: this.DsrQueryForm.startTime,
                createTimeEnd: this.DsrQueryForm.endTime,
                orderStatus: this.DsrQueryForm.orderStatus,
                vesselId: this.DsrQueryForm.vesselId,
                voyage: this.DsrQueryForm.voyage,
                mblNo: this.DsrQueryForm.mblNo,
              /*   hblNo: this.DsrQueryForm.refNo, */
                hblNo: this.DsrQueryForm.refNo,
                custBizNo: this.DsrQueryForm.shptId,
            }
             var queryData={}
             for(let i in data){
					  if(data[i]){
						  queryData[i]=data[i]
					    }
				    }
            if(queryData.mblNo){
              queryData.mblNo="%"+this.DsrQueryForm.mblNo+"%"
            }
            if(queryData.hblNo){
              queryData.hblNo="%"+this.DsrQueryForm.refNo+"%"
            }
            if(queryData.custBizNo){
              queryData.custBizNo="%"+this.DsrQueryForm.shptId+"%"
            }
             if(queryData.overseaAgentId){
                    queryOverSeaAgentOrders(queryData).then(result => {
                        if(result.success){
                            self.TableDataSource = result.records.records;
                            self.count0 = self.pageConfig.total = result.records.totalRecord;
                            self.filterStatus(result.records.records);
                            if (result.records.totalRecord === 0) {
                            self.$coreMethods.message("warning", this.$t('message.noDataExists'));
                            } else {
                            self.$coreMethods.message("success", this.$t('message.querySucceeded'));
                            }
                        }
                    })
             }else{
                 	this.$coreMethods.message(
                   "warning",this.$t('message.noMerchantFound'));
             }
        },
        handlerReset() {
            this.DsrQueryForm = {
              mblNo: '',
              refNo: '',
              startEtd: new Date(
                new Date(
                  new Date(
                    new Date().getTime() - 24 * 1000 * 3600 * 30
                  ).toLocaleDateString()
                ).getTime()
              ),
              endEtd: new Date(
                new Date(
                  new Date(
                    new Date().getTime() + 24 * 1000 * 3600 * 61
                  ).toLocaleDateString()
                ).getTime() +
                24 * 1000 * 3600 - 1
              ),
            }
        },
        handlerExcel() {
          var self = this
          var  selectData = []
          if(this.$refs.newOrderTableRef.getSelections().length>0){
            selectData = this.$refs.newOrderTableRef.getSelections()
          }else{
            if(self.TableDataSource.length>0){
              selectData = self.TableDataSource
            }
          }
          var  overseaOrderIds = []
          for(var a in selectData){
            overseaOrderIds.push(selectData[a].goOrderId)
          }
          var tableCol =this.$refs.newOrderTableRef.$children
          var str =''
          for(var i=0; i<tableCol.length-2; i++){
            str+= tableCol[i].columnSettings.data
            if(i!==tableCol.length-3){
              str+=','
            }
          }
          var url = window.location.origin+'/api/cts-order-service/daoService/excelExport/custom-sql/cts-manager/queryOverseaOrder/order'
          let reqArgs = {
            goOrderIds: overseaOrderIds
          }
          if(overseaOrderIds.length>0){
            downloadExcel(reqArgs,str,url,'DSR')
          }else{
            self.$coreMethods.message('warn',this.$t('message.unableToExport'))
          }
        },
        onCarrierChange(value, selectedRows){
          this.DsrQueryForm.carrierId = selectedRows.csCustId;
          this.DsrQueryForm.carrierName = selectedRows.custAlias;
        },
        //获取订单状态数据字典
        queryEbOrderStatus() {
        let self = this;
        queryDictRows("MD_CODE_DICT$EB_OS_ORDER_TYPE").then((res) => {
            let dict = [];
            res.MD_CODE_DICT$EB_OS_ORDER_TYPE.forEach((item) => {
            let param = {};
            param.name = item.value;
            param.value = item.key;
            param.count = 0;
            param.filterList = [];
            dict.push(param);
            self.StatusList.push(param);
            });
            self.ebOsOrderType = dict;
            console.log("ebOsOrderType", dict);
            // 数据字典
            self.$hotTableUtils.registDict({EB_OS_ORDER_TYPE: dict});
        });
        },
      //获取hbl状态数据字典
      queryHblStatus() {
        let self = this;
        let params={
          codeType: "HBL_DOCUMENT_STATUS;DOCUMENT_STATUS",
          valueType: "EN"
        }
        queryDictionaryByCodeType(params).then((res) => {
          let dict = [];
          res.records.HBL_DOCUMENT_STATUS.forEach((item) => {
            let param = {};
            param.name = item.value;
            param.value = item.key;
            param.count = 0;
            param.filterList = [];
            dict.push(param);
            self.StatusList.push(param);
          });
          self.hblStatusType = dict;
          console.log("hblStatusType", dict);
          // 数据字典
          self.$hotTableUtils.registDict({HBL_DOCUMENT_STATUS: dict});
          let dict2 = [];
          res.records.DOCUMENT_STATUS.forEach((item) => {
            let param = {};
            param.name = item.value;
            param.value = item.key;
            param.count = 0;
            param.filterList = [];
            dict2.push(param);
            self.StatusList.push(param);
          });
          self.mblStatusType = dict2;
          console.log("mblStatusType", dict2);
          // 数据字典
          self.$hotTableUtils.registDict({DOCUMENT_STATUS: dict2});
        });
      },

            // 表格双击事件
     dbClickCustBizNo(val) {
      let self = this;
      let row = val.record;
      // sessionStorage.setItem("ebOrderParams", JSON.stringify([row]));
      // sessionStorage.setItem("ebOrderType", "edit");
      self.$router.push({
        path: "/overseas-agency/DsrDetail",
        query: {
          type: "edit",
          goOrderId: row.goOrderId,
        },
      });
    },
    }
};
</script>

<style scoped lang="scss">
    .position-parent {
        position: relative;
    }
    .position-title {
        position: absolute;
        top: -7px;
        background: #ffffff;
        padding: 0 4px;
    }
    #boxDiv1 {
        .title-panel-external{
          margin: 0 -5px;
          }
    }
    ::v-deep .htColumnHeaders{
        width: unset !important;
    }
   ::v-deep .el-tabs__content {
    padding:unset !important;
}
/*   ::v-deep .wtSpreader{
    left: unset !important;
} */
</style>
